import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {OrderDetails} from '../interface/order-details';
import {PaymentSession} from 'src/app/checkout/interface/payment-session';
import {PaymentSessionTransmissionService} from 'src/app/raintree/transmission/payment-session-transmission/payment-session-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {FaliureTransactionService} from 'src/app/checkout/service/faliure-transaction.service';
import {WindowRefService} from 'src/app/services/window-ref.service';
import {PaymentEntity} from 'src/app/checkout/interface/payment-entity';
import {PaymentFaliureTransaction} from 'src/app/checkout/interface/payment-faliure-transaction';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {
	SuccessFailTransactionTransmissionService
} from 'src/app/raintree/transmission/success-fail-transaction-transmission/success-fail-transaction-transmission.service';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PrepareRemainingPaymentService {

  constructor(
	private _paymentSession: PaymentSessionTransmissionService,
	public _failureTransaction: FaliureTransactionService,
	private winRef: WindowRefService,
	public _toast: ToastMessageService,
	private _transactionRequest: SuccessFailTransactionTransmissionService,
	@Inject(PLATFORM_ID) private _platformId: Object

  ) {
	this.isBrowser = isPlatformBrowser(this._platformId);
  }
  public isBrowser: boolean = false;

	public orderDetails: OrderDetails = {} as OrderDetails;

	public prepareRemainingPayment(orderDetails:OrderDetails ) {

		this.orderDetails = orderDetails;
		this._createPaymentSession(orderDetails.id+'');
	}


  	private _createPaymentSession(orderId: string) {
	let paymentSession: PaymentSession = {
		orderId: +orderId,
		paymentType: "remaining"
	}

	this._paymentSession.createPaymentSessionRequest(
		RequestMapperService.CREATE_PAYMENT_SESSION,
		paymentSession,
		() => {
		},
		() => {
		},
		(response: RaintreeResponse) => {
			debugger
			// this._toast.success(response['entity'], response.message);
			this.razorPayPayment(response['entity']);
		},
		(error: string) => {
			this._toast.error(error, error);
		},
		() => {
		}
	)
	}

	private razorPayPayment(entity: PaymentEntity) {
		const options: any = {
			order_id: entity.razorpayOrderId,
			key: entity.key,  // will come from backend
			amount: entity.amount, // will come from backend
			currency: entity.currency, // will come from backend
			name: 'Anuprerna', // company name
			image: 'https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/static-data/Anuprerna+A-10.svg', // company logo or product image
			prefill: {
				// fill from billing details
				"name": this.orderDetails.address.billingAddress.name, //your customer's name addOrderData
				"email": this.orderDetails.address.billingAddress.contactEmail,
				"contact": this.orderDetails.address.billingAddress.primaryPhone
			},
			modal: {
				// We should prevent closing of the form when esc key is pressed.
				escape: false,
			},
			notes: {
				// include notes if any
			},
			theme: {
				color: '#EFEEE9'
			},
			retry: {
				enabled: true
			}
		};

		let errorSchema: PaymentFaliureTransaction = {
			"loomOrderId": this.orderDetails.id,
			"razorpayOrderId": entity.razorpayOrderId,
			"error": {
				"code": "BAD_REQUEST_ERROR",
				"description": "Payment was unsuccessful due to a temporary issue. If amount got deducted, it will be refunded within 5-7 working days.",
				"source": "gateway",
				"step": "payment_response",
				"reason": "payment_failed",
				"metadata": {
					"payment_id": "pay_MTDXwCG7PeHNzj",
					"order_id": "order_MTDWsDlIrRwJXk"
				}
			}
		}


		options.handler = ((response: any) => {
			options.response = response;
			// console.log(response);
			// call your backend api to verify payment signature & capture transaction
			this._paymentSuccess(response, this.orderDetails.id)
		});
		options.modal.ondismiss = (() => {
			// handle the case when user closes the form while transaction is in progress
			this._paymentFailRequest(errorSchema)
			console.log('Transaction cancelled.');
		});
		let context = this;
		let rzp:any = {} as any;

		if (this.isBrowser) {
			rzp = new this.winRef.nativeWindow.Razorpay(options);
		}
		rzp.on('payment.failed', function (response: any) {
			// console.log(response);
			let sendResponse: PaymentFaliureTransaction = {
				loomOrderId: context.orderDetails.id,
				razorpayOrderId: entity.razorpayOrderId,
				paymentType: "remaining",
				...response
			}
			context._faliureRequest(sendResponse)
		});
		rzp.open();
	}


	private _paymentSuccess(responsedata: any, orderId: number): void {
		let payload: any = {
			"loomOrderId": orderId,
			"paymentType": "remaining",
			"razorpayOrderId": responsedata.razorpay_order_id,
			"transactionId": responsedata.razorpay_payment_id,
			"transactionSignature": responsedata.razorpay_signature
		}
		// debugger
		this._paymentSuccessRequest(payload)
	}
	private _paymentSuccessRequest(payload: any) {

		this._transactionRequest.sussessTransaction(
			RequestMapperService.PAYMENT_SUCCESS,
			payload,
			() => { },
			() => { },
			(response: RaintreeResponse) => {
				// debugger
				this._toast.success(response.message, response.message);
				if (this.isBrowser)
					window.location.reload();
			},
			(error: string) => {
				// debugger
				this._toast.error(error, error);
			},
			() => {
			}
		)
	}

	private _faliureRequest(error: PaymentFaliureTransaction) {
		// debugger
		// console.log("faliure called");
		this._paymentFailRequest(error)
	}

	private _paymentFailRequest(payload: PaymentFaliureTransaction) {

		this._transactionRequest.failTransaction(
			RequestMapperService.PAYMENT_FAIL,
			payload,
			() => { },
			() => { },
			(response: RaintreeResponse) => {
				// debugger
				this._toast.success(response.message, response.message);
			},
			(error: string) => {
				// debugger
				this._toast.error(error, error);
			},
			() => {
			}
		)
	}
}
